import { useCallback, useEffect } from "react";

type PropTypes = {
  mediaLength: number;
  setCurrentPhotoIndex: React.Dispatch<React.SetStateAction<number>>;
};

export const useSliderNavigation = ({
  mediaLength,
  setCurrentPhotoIndex,
}: PropTypes) => {
  const navigation = useCallback(
    (direction: "prev" | "next") =>
      (_e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e?.stopPropagation();

        setCurrentPhotoIndex((oldIndex) => {
          const newPhotoIndex =
            direction === "prev" ? oldIndex - 1 : oldIndex + 1;

          if (newPhotoIndex < 0) {
            return 0;
          }

          // if (!media || !media.length) {
          //   return 0;
          // }

          if (newPhotoIndex > mediaLength - 1) {
            return mediaLength - 1;
          }

          return newPhotoIndex;
        });
      },
    [mediaLength, setCurrentPhotoIndex],
  );

  useEffect(() => {
    // keyboard arrow navigation
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        navigation("prev")();
      }

      if (e.key === "ArrowRight") {
        navigation("next")();
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [navigation]);

  return {
    navigation,
  };
};
